<template>
  <div class="contentBox">
    <div class="container">
      <div class="article">
        <div class="text page-title">
          Vui lòng xác nhận có xóa tài khoản này không
        </div>
        <div class="text">
          Người chơi thân mến, bạn đang thực hiện thao tác xóa tài khoản, vui
          lòng xác nhận lần cuối xem có muốn xóa tài khoản này không.
        </div>
        <div class="btn-list">
          <div class="btn active" @click="handleCheck">YES</div>
          <div class="btn active" @click="handleReturn">NO</div>
        </div>
      </div>
    </div>
    <div data-v-0186101b="" class="mt-logo"></div>
  </div>
</template>

<script>
export default {
  name: "",
  mixins: [],
  components: {},
  props: {},
  data() {
    return {
      token: "",
    };
  },
  computed: {},
  watch: {},
  created() {
    let token = this.$route.query.t;
    if (token) {
      this.token = token;
    }
  },
  mounted() {},
  methods: {
    handleCheck() {
      let params = {
        token: this.token,
      };
      this.$http.post("/main/check", params).then((res) => {
        if (res.data.code === 200) {
          this.$router.push("/main/deletion/regulation1");
          this.$message.success(res.data.msg);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    handleReturn() {
      this.$router.push("/main/deletion/regulation1");
    },
  },
};
</script>

<style scoped lang="scss">
@import "./css/index.css";
</style>
